import { type CanvasData } from "@/services/apitypes";

type CanvasStats = CanvasData["stats"];

function toCount(value: unknown): number | null {
  if (value == null) {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return null;
    }
    const numericValue = Number(trimmed);
    return Number.isFinite(numericValue) ? numericValue : null;
  }

  return null;
}

function hasEmptyLegacyStatsSignal(statistics: CanvasStats): boolean {
  const respondentCount = toCount(statistics?.respondent_count);
  const invitedCount = toCount(statistics?.invited_count);

  const hasNullSignal = respondentCount == null && invitedCount == null;
  const hasZeroSignal = respondentCount === 0 && invitedCount === 0;

  return hasNullSignal || hasZeroSignal;
}

export function shouldUseLegacyCanvasPresentation(canvas?: CanvasData | null): boolean {
  if (!canvas) {
    return false;
  }

  return hasEmptyLegacyStatsSignal(canvas.stats);
}
